import Route from '@ember/routing/route';

export default class AuthenticatedReimaginedIdrRoute extends Route {}
